<div class="date-picker">
  <input
    id="date-input"
    type="date"
    [formControl]="dateControl"
    [min]="minDate"
    [max]="maxDate"
    class="date-picker__input"
  />
</div>
